import {event} from '../modules/event';

var Tabs = class {
	constructor(wrapper) { 
		this._createElements(wrapper);
		this._addEvents();
	}
	
	_createElements(wrapper){
        var self = this;
		this.wrapper = wrapper;
		this.btnAll = this.wrapper.querySelectorAll('[data-Tabs-btn]');
        this.preview = this.wrapper.getAttribute('data-param') ? document.getElementById(this.wrapper.getAttribute('data-param')) : false;
        this.curBtn;
	}

	_addEvents(){
		var self = this;

        for(var i=0,j=this.btnAll.length; i<j; i++){
            if(this.btnAll[i].className.indexOf('js-active') !== -1){
                this.curBtn = this.btnAll[i];
                this.curBtn.tabContent = this._getContent(this.curBtn);
            }

            event.add(this.btnAll[i], 'click', function(e){
                e.preventDefault();
                self._showTab.call(self, this);
            })
        }
	}

    _getContent (btn){
        var uid=btn.hash.substr(1, btn.hash.length );
        return document.getElementById(uid);
    }

    _showTab(btn){
        if(btn.className.indexOf('js-active') !== -1) return;
        if(!btn.tabContent) btn.tabContent = this._getContent(btn);

        if(this.preview) {
            this.preview.parentNode.removeChild(this.preview);
            this.preview = false;
        }

        btn.className = btn.className + ' js-active';
        btn.tabContent.className = btn.tabContent.className + ' js-active';

        this.curBtn.className = this.curBtn.className.replace(' js-active', '');
        this.curBtn.tabContent.className = this.curBtn.tabContent.className.replace(' js-active', '');

        this.curBtn = btn;
    }
};

export {Tabs};





































